import React from "react";
import { ProtectedPageWrapper } from "../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { LoadingPageOverlay } from '../designSystem/LoadingPageOverlay';
import { SingleColumnLayout } from '../designSystem/layouts/SingleColumnLayout';
import { P } from "../designSystem/typography/Body";
import { getActionPlansForActiveUser } from "../api/actionPlanClientApi";
import { ActionPlanListView } from '../amorg-common/DTOs/ActionPlanListView';
import { PageHeader } from "../designSystem/PageHeader";
import { Flex } from "../designSystem/compositeComponents/FlexHelpers";
import { ActionPlanListingView } from "./actionplans/components/ActionPlanListingView";
import { MessageCard } from "../designSystem/Message";

export function UserLandingPage():JSX.Element
{
    const [actionplans, setActionplans] = React.useState<ActionPlanListView[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(function(){
        const getData = async () => {
            setActionplans(await getActionPlansForActiveUser());
            setLoading(false);
        }
        getData();
    }, [])

    return (
        <ProtectedPageWrapper requiredPermissions={['ViewAssignedActionPlans']}>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        {loading &&
                            <LoadingPageOverlay loading={loading} />
                        }
                        
                        {!loading && 
                            <Content actionplans={actionplans} />
                        }
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}

function Content(props:{actionplans:ActionPlanListView[]}):JSX.Element
{
    return (
        <>
            <PageHeader headerText="Handleplaner" headerStyle="secondary-gray" />
            
            {props.actionplans.length === 0 &&
                <MessageCard variant="info">
                    <Flex flexDirection="column" gap={16}>
                        <P>Velkommen som bruger af AMORG</P>
                    
                        <P>Du er endnu ikke tildelt handleplaner eller en rolle med AMO adgang.</P>
                    
                        <P>Hvis du mener dette er en fejl, bør du kontakte din AMO gruppe.</P>
                    </Flex>
                </MessageCard>
            }

            {props.actionplans.length > 0 &&
                <>
                    <P>Du er valgt som ansvarlig for følgende handleplaner</P>
                    
                    <Flex flexDirection="column" gap={16} style={{marginTop:'16px'}}>
                        {props.actionplans.map(ap => {
                            return (
                                <ActionPlanListingView key={ap.id} item={ap} />
                            );
                        })}
                    </Flex>
                </>
            }
        </>
    );
}